import {
  Box,
  Text,
  Spacer,
  Input,
  Modal,
  ModalBody,
  Button,
  Grid,
} from "@flexisaf/flexibull2";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import useQuizathonEditor from "../../../hooks/quizathon/useQuizathonEditor";
import useQuizathonListGet from "../../../hooks/quizathon/useQuizathonListGet";
import Theme from "../../../theme";
import moment from "moment";

const getDefaultFields = () => ({
  title: "",
  startTime: "",
  endTime: "",
  maxParticipantAllowed: "",
});

const QuizathonEditor = ({ onClose, isOpen , data}) => {
  const {
    register,
    watch,
    formState: { errors },
    setValue,
    handleSubmit,
    reset
  } = useForm({
    defaultValues: {
      ...getDefaultFields(),
    },
  });
  const { refetch } = useQuizathonListGet();
  const { createQuizathon, isCreatingQuizathon, isEditingQuizathon, editQuizathon } = useQuizathonEditor();
  const handleClose = () => {
    reset({
      ...getDefaultFields(),
    });
    onClose();
  };
  const handleCreateQuizathon = (values) => {
    const payload = {
      data: {
        title: values.title,
        startAt: values.startTime,
        stopAt: values.endTime,
        isActive: true,
        maxParticipants: values.maxParticipantAllowed,
      },
      callback: () => {
        handleClose()
        refetch();
      },
    };

    createQuizathon(payload);
  };
  const handleEditQuizathon = (values)=>{
    const payload = {
      data: {
        id: data?.id,
        title: values.title,
        startAt: values.startTime,
        stopAt: values.endTime,
        isActive: true,
        maxParticipants: values.maxParticipantAllowed,
      },
      callback: () => {
        handleClose()
        refetch();
      },
    };

    editQuizathon(payload);
  }

  useEffect(() => {
    if (data?.id) {
      setValue("title", data?.title );
      setValue("startTime", moment(data?.startAt).format("YYYY-MM-DDTHH:mm"));
      setValue("endTime", moment(data?.stopAt).format("YYYY-MM-DDTHH:mm"));
      setValue("maxParticipantAllowed", data?.maxParticipants );
    } 
  }, [data, setValue]);
  return (
    <Modal  onClose={handleClose}  open={isOpen} center={false}>
      <ModalBody width="40vw">
        <Box pad="1.3rem 1.5rem"  >
          <Text bold block size="18px">
            Create Quizathon
          </Text>
          <Spacer space={10} />
          <Text block>
            Allows user to create a quizathon for students, set time and date,
            and other features
          </Text>
          <Spacer space={30} />
          <Box pad="0.6rem" >
            <Input
              spaceTop
              type="text"
              label={"Quizathon Title"}
              required={true}
              value={watch("title")}
              placeholder={`Enter Title`}
              {...register("title", {
                required: `Quizathon title is required`,
              })}
              onChange={({ target: { value } }) => setValue("title", value)}
              error={errors.title?.message}
              style={{ width: "100%" }}
            />
            <Spacer space={40} />
            <Input
              type="datetime-local"
              label={"Quizathon Start Time"}
              style={{ width: "100%" }}
              value={watch("startTime")}
              {...register("startTime", {
                required: `startTime is required`,
              })}
              error={errors.startTime?.message}
              onChange={({ target: { value } }) => setValue("startTime", value)}
            />
            <Spacer space={50} />

            <Input
              type="datetime-local"
              label={"Quizathon End Time"}
              value={watch("endTime")}
              {...register("endTime", {
                required: `End time is required`,
                validate: (value) =>
                  value > watch("startTime") ||
                  "End time must be after start time",
              })}
              error={errors.endTime?.message}
              onChange={({ target: { value } }) => setValue("endTime", value)}
              style={{ width: "100%" }}
            />
            <Spacer space={30} />

            <Input
              spaceTop
              type="number"
              label={"Maximum Participant Allowed"}
              required={true}
              placeholder={`Enter Number`}
              value={watch("maxParticipantAllowed")}
              {...register("maxParticipantAllowed", {
                required: `maxParticipantAllowed is required`,
              })}
              error={errors.maxParticipantAllowed?.message}
              onChange={({ target: { value } }) =>
                setValue("maxParticipantAllowed", value)
              }
              style={{ width: "100%" }}
            />
          </Box>
        </Box>
        <Spacer space={70} />
        <Box background="#E3E5E5" pad="1.3rem">
          <Grid default="1fr auto auto">
            <Box />
            <Button
              onClick={handleClose}
              style={{
                backgroundColor: "white",
                color: "black",
                marginRight: "1rem",
              }}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: Theme.NewPrimaryColor,
              }}
              progress={isCreatingQuizathon || isEditingQuizathon} 
              onClick={handleSubmit((v) => {
                if (data?.id) {
                  handleEditQuizathon(v);
                } else {
                  handleCreateQuizathon(v);
                }
              })}
            >
             {data?.id ? "Edit Quizathon" :"Save Quizathon" } 
            </Button>
          </Grid>
        </Box>
      </ModalBody>
    </Modal>
  );
};

export default QuizathonEditor;
